export default "__VITE_ASSET__BwYNm7nQ__";